// extracted by mini-css-extract-plugin
module.exports = {"customLink":"FooterLink_customLink__MyUlF"};